module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABCUlEQVQ4T+WSL0vFYBTGn/Nugt6wZtsXMNkMA8G6bBSLcNUk1s0zWDgvGLUZBG0aNBoNouIHMCoaLEvLFzbeIy/cXRS82wfwtPPn9xx4eAgDVZblqGmaXSK6E5G37pz6uKIoVlX1CsAKgAsR2RkCKc/zA2PMMYBPVV0ioicR2Z4LZlm2bIy5BJAS0XkYhodt294DeP8FMvORV1FVMsYsqOpYVRcBjK21t37HzC8A/Oxm9pGZFcAEgAuCYOSce3TObVlrv7ojZvYf16Z96EVoCu6nafoM4JWINpIkeZhnGjPvATj7T+B1FEUfcRznVVWd1nU9i9YfJq0D2OzMGYrsz32rqie9We1T+wZQUYcbIqKpEAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/myGive_icon/44.png
// module id = rQDL
// module chunks = 0